"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _mapTo = require("rxjs/operators/mapTo");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _of = require("rxjs/observable/of");

var _requestEntity = _interopRequireDefault(require("../requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("../RequestEpicDescriptor"));

var _actions = require("./actions");

var _constants = require("./constants");

var _selectors = require("./selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _I18n = _interopRequireDefault(require("I18n"));

var _enviro = _interopRequireDefault(require("enviro"));

var _API = _interopRequireDefault(require("./API"));

var _usageTrackerRedux = require("usage-tracker-redux");

var _fromPromise = require("rxjs/observable/fromPromise");

var track = _usageTrackerRedux.usageTrackerActions.track;
var fetchShopifyStatus = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getShopifyStatus,
  initiatingActionType: _actions.EcommerceActionTypes.FETCH_SHOPIFY_STATUS,
  requestStatusSelector: _selectors.getFetchShopifyStatusRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchShopifyStatus
}));
var disconnectShopify = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.disconnectShopify,
  initiatingActionType: _actions.EcommerceActionTypes.DISCONNECT_SHOPIFY,
  requestStatusSelector: _selectors.getDisconnectShopifyRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.DisconnectShopify
}));
var fetchInstalledEcommerceAppIds = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getInstalledEcommerceIntegrationIds,
  initiatingActionType: _actions.EcommerceActionTypes.FETCH_INSTALLED_ECOMMERCE_APP_IDS,
  requestStatusSelector: _selectors.getFetchInstalledEcommerceAppIdsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchInstalledEcommerceAppIdsActions
})); // ============================================================================

var fetchShopifyShopIfInstalled = function fetchShopifyShopIfInstalled(action$) {
  return action$.ofType(_actions.FetchShopifyStatusActionTypes.SUCCESS).pipe((0, _filter.filter)(function (action) {
    return action.payload.data.integrationStatus === _constants.IntegrationStatuses.INTEGRATED || action.payload.data.integrationStatus === _constants.IntegrationStatuses.WARNING;
  }), (0, _mergeMap.mergeMap)(function (action) {
    return (0, _fromPromise.fromPromise)(_API.default.getShopifyShop()).pipe((0, _map.map)(function (resp) {
      return _actions.FetchShopifyShop.success(resp, action.payload.data);
    }), (0, _catchError.catchError)(function (err) {
      return (0, _of.of)(_actions.FetchShopifyShop.failure(err, action.payload.data));
    }), (0, _startWith.startWith)(_actions.FetchShopifyShop.request(action.payload.data)));
  }));
};

var trackShopifyDisconnect = function trackShopifyDisconnect(action$) {
  var id = _enviro.default.isQa() ? _constants.SHOPIFY_APP_ID_QA : _constants.SHOPIFY_APP_ID_PROD;
  return action$.ofType(_actions.DisconnectShopifyActionTypes.SUCCESS).pipe((0, _mapTo.mapTo)(track('susIntegrationDisconnected', {
    what_value: id
  })));
};

var I18n_BASE = 'ecommerce.dashboard.disconnect';

var displayShopifyDisconnectFailureAlert = function displayShopifyDisconnectFailureAlert(action$) {
  return action$.ofType(_actions.DisconnectShopifyActionTypes.FAILED).pipe((0, _mapTo.mapTo)({
    type: _actions.EcommerceActionTypes.SHOW_DISCONNECT_SHOPIFY_FAILURE_ALERT,
    meta: {
      notification: {
        titleText: _I18n.default.text(I18n_BASE + ".failed.header"),
        message: _I18n.default.text(I18n_BASE + ".failed.body"),
        type: 'success'
      }
    }
  }));
};

var _default = (0, _reduxObservable.combineEpics)(fetchShopifyStatus, fetchShopifyShopIfInstalled, disconnectShopify, fetchInstalledEcommerceAppIds, trackShopifyDisconnect, displayShopifyDisconnectFailureAlert);

exports.default = _default;
module.exports = exports.default;